export default __webpack_public_path__ + "static/media/Blue and Yellow Minimalist Employee of the Month Certificate (2).89c83733.png";